/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

/**
 * Handles session expiration by clearing storage and showing the SessionExpiredDialog.
 * 
 * NOTE: This is now handled automatically by apiFetch.js for most cases.
 * Only use this directly if you need to manually trigger session expiration
 * (e.g., user clicks "Logout" button).
 * 
 * @param {string} reason - The reason for expiration ('idle-timeout', 'token-expired', 'manual', etc.)
 */
export const handleSessionExpiredClose = (reason = 'token-expired') => {
    sessionStorage.clear();
    
    // Dispatch event for SessionExpiredDialog to show
    window.dispatchEvent(new CustomEvent('sessionExpired', { 
        detail: { reason } 
    }));
};